import { GroupFragment, isGroupFragment } from './GroupFragment'

import { ContactFragment, isContactFragment } from './ContactFragment'

import detailedGroupFragmentRawString from '../DetailedGroupFragment.graphql'

export const detailedGroupFragmentString = detailedGroupFragmentRawString

export type DetailedGroupFragment = GroupFragment & {
  members: ContactFragment[]
}

export const isDetailedGroupFragment = (
  fragment: any,
): fragment is DetailedGroupFragment =>
  (isGroupFragment(fragment) as boolean) &&
  Array.isArray(fragment.members) &&
  fragment.members
    .slice(0, 5)
    .reduce(
      (accum: any, next: any) => accum && (isContactFragment(next) as boolean),
      true,
    )
